define('modules/util/collection/collection_view',[
  'backbone',
  'jquery',
  '_',
  'session',

  'modules/pagination/pagination_view',
  'modules/order_table/order_table',
  'modules/search_field/search_field_view',
  'modules/button/button_view',
  'modules/util/buttons/buttons_view',
  'modules/modal/modal_view',
  'modules/player/media/local/modal/disconnect_last_zone_modal_view',

  'text!./collection_actions_template.html',
  'text!./list_item_template.html',
  'text!./list_items_template.html',
  'text!./collection_template.html'
], function (Backbone, $, _, session,
             PaginationView,
             orderTable,
             SearchFieldView,
             ButtonView,
             ButtonsView,
             ModalView,
             DisconnectLastZoneModalView,

             actions_template,
             item_template,
             items_template,
             collection_template) {
  'use strict';
  var CollectionView = Backbone.View.extend({
      defaults: {
        pagination: true,
        header: true,
        search: true,
        filter: false,
        buttons: null

      },
      initialize: function (opts) {

        _.extend(this, opts);
        this.options = _.merge({}, this.defaults, opts.options || {});


        this.renderedItems = [];
        this.viewType = (this.viewType) ? this.viewType : CollectionView.LIST;

        this.collection = this.items;

        this.listenTo(this.collection, 'sync', function(collection) {
          this.renderHeader();
          this.renderList();
          this.renderPagination();
        }, this);

        this.render();
        if(this.options.filter || this.options.search || this.options.searchTags || this.options.buttons || this.itemView.viewTypes.length > 1) {
          this.renderActions();
        }

        if (this.options.pagination) {
          this.renderPagination();
        }

        if(this.options.filter) {
          this.renderFilters();
        }

        if(this.options.search) {
          this.renderSearch();
        }

        if(this.options.searchTags) {
          this.renderSearchTags();
        }

        if(this.options.buttons) {
          this.renderButtons();
        }
        if(this.itemView.viewTypes && this.itemView.viewTypes.length > 1) {
          this.renderViewTypeButtons();
        }
        
        if (this.$('input:checkbox.js-item-checkbox').length === 0) {
          this.$('.player-header-item--checkbox').remove();
        }
        else {
          this.$('.js-header-checkbox').change(function () {
            var checkboxes = $('input:checkbox.js-item-checkbox');
            checkboxes.prop('checked',this.checked);
            if (this.checked) {
              $('.js-header-disconnect-button').removeClass('hidden');
              $('.player-header-item').hide();
              $('.player-header-item--checkbox').show();
              $('.js-disconnect-location').hide();
            }
            else {
              $('.js-header-disconnect-button').addClass('hidden');
              $('.js-disconnect-location').show();
              $('.player-header-item').show();
            }
          });
          this.$('input:checkbox.js-item-checkbox').change(function () {
            // Check all with same booking id
            $('input:checkbox.js-item-checkbox[value=' + this.value + ']').prop('checked',this.checked);

            if ($('input:checkbox.js-item-checkbox:checked').length > 0) {
              $('.js-header-disconnect-button').removeClass('hidden');
              $('.js-header-checkbox').prop('checked', true);
              $('.player-header-item').hide();
              $('.player-header-item--checkbox').show();
              $('.js-disconnect-location').hide();
            }
            else {
              $('.js-header-disconnect-button').addClass('hidden');
              $('.player-header-item').show();
              $('.js-header-checkbox').prop('checked', false);
              $('.js-disconnect-location').show();
            }
          });
        }
      },

      subViews: [],

      actions_template: _.template(actions_template),
      item_template: _.template(item_template),
      items_template: _.template(items_template),
      collection_template: _.template(collection_template),

      events: {
        'click .js-search-customers': 'showSearchField',
        'click .collection-header-item [data-order-by]': 'orderTableHandler',
        'click .js-collections-view-list': 'listView',
        'click .js-collections-view-grid': 'gridView',
        'click .js-header-disconnect-button': 'clickDisconnectBookingsFromLocation'
      },

      tagName: 'div',
      className: 'collection-util',

      clickDisconnectBookingsFromLocation: function (e) {
        e.preventDefault();
        var disconnectModal = new ModalView({
          title: _.t('modal.header.disconnect_ads_from_last_zone'),
          modalContent: new DisconnectLastZoneModalView({messageText: _.t('modal.text.disconnect_ads_from_last_zone')})
        });

        disconnectModal.open();

        this.listenToOnce(disconnectModal.modalContent, 'disconnectAd', function () {
          var bookingsToDisconnect = [];
          var checkboxes = $('input:checkbox.js-item-checkbox:checked');
          for (var i = 0; i < checkboxes.length; i++) {
            if ((bookingsToDisconnect.indexOf(checkboxes[i].value) === -1)) {
              bookingsToDisconnect.push(checkboxes[i].value);
            }
          }
          console.log(bookingsToDisconnect);

          $.ajax({
            type: 'POST',
            data: JSON.stringify({ 'bookingids': bookingsToDisconnect, 'locationid': session.get('location_id')}),
            contentType: 'application/json; charset=UTF-8',
            url: session.get('apiUrl') + 'bookings/removelocations'
          }).success(function (data) {
            checkboxes.closest('.player-items').remove();
          }.bind(this));
        });
      },

      render: function () {
        this.$el.html(this.collection_template());

        this.renderHeader();
        this.renderList();

        this.changeHeaderClass();

        return this;
      },


      renderFilters: function () {
        this.$('.js-collection-filter').html(this.options.filter);
        return this;
      },

      renderButtons: function () {
        this.$('.js-collection-actions').html(this.options.buttons);
      },

      renderSearch: function () {
          var searchField = new SearchFieldView({collection: this.collection});
            this.subViews.push(searchField);
            this.$('.js-collection-search-field').html(searchField.$el);
      },

      renderSearchTags: function () {
        var that = this;

        this.$('.js-collection-search-field').selectize({
          plugins: ['remove_button','freetext_search'],
          create: false,
          closeAfterSelect: true,
          maxOptions: 5,
          delimiter: ' ',
          placeholder: _.t('search_field.placeholder'),
          onItemAdd: function (value, $item) {
            // that.clearSelectizeOptions();
            // console.log('value', value);
            // console.log('$item', $item);
            that.$('.js-collection-search-field')[0].selectize.refreshOptions();

          },
          onChange: function(value) {
              // console.log('searchTagControl - onChange', value);

            if (!value || value.length === 0) {
              // console.log('searchTagControl - onChange clearing');

              that.clearSelectizeOptions();
              that.refreshCollection(value);
              return;
            }
            that.refreshCollection(value);

          },
          onType: function(value) {
            // console.log('searchTagControl - onType clearing');

            if (!value || value.trim() == '') { 
              // console.log('searchTagControl - onType clearing');
              this.close();
              return; 
            }

            var payload = {
              searchText: value,
              maxTags: 5
            };

            $.ajax({
              type: 'GET',
              // contentType: 'application/json; charset=UTF-8',
              url: session.get('apiUrl') + 'tags/search',
              data: payload,
              dataType: 'json'
            }).success(function (data) {
              for(var i = 0; i < data.length; i++) {
                that.$('.js-collection-search-field')[0].selectize.addOption({value: data[i], text: data[i]});
              }
            }.bind(this));
          }
        });
      },

      clearSelectizeOptions: function() {
        this.$('.js-collection-search-field')[0].selectize.clearOptions();
        this.$('.js-collection-search-field')[0].selectize.refreshOptions();
      },

      refreshCollection: function(searchText) {
        this.collection.params = _.extend(this.collection.params, {
          search: searchText,
          offset: 0
        });
  
        this.collection.fetch();
      },

      renderViewTypeButtons: function () {
          var buttons = [];
          this.itemView.viewTypes.forEach(function (type) {
            var active = (type === this.viewType) ? ' active' : '';
            buttons.push(new ButtonView({
              icon: (type + active),
              className: ('js-collections-view-' + type + ' button' + active)
            }));
          }, this);
          var buttonsView = new ButtonsView({items: buttons});
          this.subViews.push(buttonsView);
          this.$('.js-collections-view-buttons').html(buttonsView.$el);
      },


      renderActions: function () {
        this.$('.js-actions').html(this.actions_template());
      },

      renderHeader: function () {
        if (this.options.header && this.itemView.header) {
          var header = this.itemView.header(this.collection);
          this.subViews.push(header);
          this.$('.js-collection-header').html(header);
        }
      },

      renderList: function () {

        var rows = this.collection.map(this.renderListItem, this);

        var $values = $(this.items_template());
        $values.addClass((this.viewType === CollectionView.LIST ? 'collection--list' : 'Collection-grid'));
        $values.append(rows);

        this.$('.js-collection-items').html($values);
      },

      renderListItem: function(item) {
        var collectionItem = new this.itemView({
            model: item,
            extraParams: this.extraParams,
            viewType: this.viewType,
            tagName: 'li',
            className: 'collection-item ' + (this.viewType === CollectionView.LIST ? 'list-item' : 'GridItem')
          });
          this.subViews.push(collectionItem);
          return collectionItem.$el;
      },

      renderPagination: function () {
        if (this.paginationView) {
          this.paginationView.remove();
        }
        this.paginationView = new PaginationView(this.collection);
        this.subViews.push(this.paginationView);

        this.$('.js-pagination').html(this.paginationView.$el);
        this.paginationView.delegateEvents();
      },

      orderTableHandler: function (e) {
        e.preventDefault();
        orderTable($(e.currentTarget), this.collection);
      },

      showSearchField: function (e) {
        e.preventDefault();
        this.$('.js-search-customers-input').addClass('expanded').focus();
      },

      gridView: function (e) {
        e.preventDefault();
        this.setViewType(CollectionView.GRID);
      },

      listView: function (e) {
        e.preventDefault();
        this.setViewType(CollectionView.LIST);
      },

      setViewType: function (viewType) {
        var oldViewType = this.viewType;
        this.$('.js-collections-view-' + oldViewType).removeClass('active').find('span').removeClass('active');
        this.$('.js-collections-view-' + viewType).addClass('active').find('span').addClass('active');

        this.viewType = viewType;
        this.renderList();
        this.changeHeaderClass();
      },

      changeHeaderClass: function () {
        $(this.el).removeClass((this.viewType !== CollectionView.LIST ? 'collection-list' : 'collection-grid'));
        $(this.el).addClass((this.viewType === CollectionView.LIST ? 'collection-list' : 'collection-grid'));
      },

      remove: function () {
        _.each(this.subViews, function (view) {
          if (view && view.remove) {
            view.remove();
          }
        });
        this.$el.off();
        this.$el.remove();
        this.stopListening();
        return this;
      }

    }, {
      LIST: 'list',
      GRID: 'grid'
    }
  );
  return CollectionView;
});

